export default __webpack_public_path__ + "static/media/vesta.01ec40da.jpg";